import { CommonModule } from '@angular/common';
import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'validation-errors',
    styleUrls: ['../../base/base-form-kit.scss'],
    styles: [
        `
      ::ng-deep mat-error.mat-mdc-form-field-bottom-align::before {
        display: inherit !important;
        height: 0px !important;
      }
    `,
    ],
    imports: [CommonModule, TranslateModule, MatFormFieldModule],
    templateUrl: './validation-errors.component.html'
})
export class ValidationErrorsComponent {
  @Input() control: FormControl | any;
  @Input() label: string = '';
  @Input() inputChangeEvent: any;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() max: number;
  @Input() min: number;
  subscription: Subscription;

  errMsg: string = '';
  #translate = inject(TranslateService);

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.label) this.label = this.#translate.instant(this.label);
    if (changes.inputChangeEvent) this.handleValidationErrors();
  }

  handleValidationErrors() {
    try {
      this.errMsg = '';
      const control: FormControl = this.control;
      if (!this.label) return;
      if (!control?.errors) return;
      if (!Object?.keys(control.errors)?.length) return;

      const maxLength =
        this.maxLength || control?.getError('maxlength')?.requiredLength;
      const minLength =
        this.minLength || control?.getError('minlength')?.requiredLength;
      const min =
        this.min ||
        control?.getError('minNumber')?.requiredLength ||
        control?.getError('min')?.requiredLength;
      const max =
        this.max ||
        control?.getError('maxNumber')?.requiredLength ||
        control?.getError('max')?.requiredLength;
      const error = Object?.keys(control.errors)[0];

      switch (error) {
        case 'minlength':
          this.errMsg = this.#translate.instant(
            'messages.validationError.minLength',
            { title: `${this.label}`, minLength: `${minLength}` }
          );
          break;
        case 'maxlength':
          this.errMsg = this.#translate.instant(
            'messages.validationError.maxLength',
            { title: `${this.label}`, maxLength: `${maxLength}` }
          );
          break;
        case 'minNumber':
        case 'min':
          this.errMsg = this.#translate.instant(
            'messages.validationError.min',
            { title: `${this.label}`, min: `${min}` }
          );
          break;
        case 'maxNumber':
        case 'max':
          this.errMsg = this.#translate.instant(
            'messages.validationError.max',
            { title: `${this.label}`, max: `${max}` }
          );
          break;
        case 'email':
          this.errMsg = this.#translate.instant(
            'messages.validationError.invalidEmail'
          );
          break;
        case 'mismatch':
          this.errMsg = this.#translate.instant(
            'messages.validationError.confirmPassword'
          );
          break;
        default:
          this.errMsg = this.#translate.instant(
            'messages.validationError.invalid',
            { title: `${this.label}` }
          );
          break;
      }
    } catch (error) {
      console.error('Validation Error => ', error);
    }
  }
}
